export enum AMLIncomeSource {
    Employment = "Mzda/plat ze zaměstnání",
    Business = "Příjem z podnikání, členství v orgánu společnosti, společnictví či prokury",
    Other = "Jiné",
}

export interface AMLFormValues {
    employmentType: string | undefined;
    businessIncomeId: string | undefined;
    otherIncomeId: string | undefined;
    averageIncome: string | undefined;
    incomeSourceSpecification: string | undefined;
    propertySourceSpecification: string | undefined;
    usaResident: boolean;
    greenCardHolder: boolean;
    politicallyExposed: boolean;
    taxResidence: string;
    taxNumber: string | undefined;
    propertySources: Record<number, boolean>;
    submitError: string | undefined;
}

export const AMLFormDefaultValues: AMLFormValues = {
    employmentType: "",
    businessIncomeId: "",
    otherIncomeId: "",
    incomeSourceSpecification: undefined,
    propertySourceSpecification: undefined,
    averageIncome: undefined,
    greenCardHolder: false,
    politicallyExposed: false,
    usaResident: false,
    taxResidence: "CZE",
    taxNumber: undefined,
    propertySources: {},
    submitError: undefined,
};
